import React, { useEffect, useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import banner1 from "../../assets/productimage.avif";
import banner2 from "../../assets/productbanner.jpg";
import banner3 from "../../assets/banner3.avif";
import { MdFilterList, MdArrowDropDown } from "react-icons/md";
import { CustomeStyle } from "../../Css/CustomeStyle";
import Footer from "../../Fotter";
import { AddWishlist } from "../../redux/slices/AddWishlistSlice";
import { useDispatch } from "react-redux";

function SubCategoryData() {
  const dispatch = useDispatch();
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState("");
  const [selectedOffer, setSelectedOffer] = useState("");
  const [availability, setAvailability] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isSidebarVisible1, setIsSidebarVisible1] = useState(false); // Controls dropdown visibility
  const [selectedOption, setSelectedOption] = useState("Default Sorting"); // Tracks selected option

  const options = [
    "Default Sorting",
    "Sort by price: low to high",
    "Sort by price: high to low",
    "Sort by latest",
  ];

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsSidebarVisible1(false);
  };

  const categories = [
    "Electronics",
    "Home Appliances",
    "Fashion",
    "Sports & Outdoors",
    "Toys & Games",
    "Books",
    "Automotive",
    "Beauty & Health",
    "Furniture",
    "Groceries",
  ];

  const brands = ["Apple", "Samsung", "Sony", "LG", "Nike", "Adidas"];

  const discounts = ["10% Off", "20% Off", "30% Off"];

  const offers = ["Buy More, Save More", "Special Price", "No Cost EMI"];

  const images = [banner1, banner2, banner3];

  const handleClearAll = () => {
    setSelectedCategory("");
    setSelectedBrand([]);
    setSelectedDiscount("");
    setSelectedOffer("");
    setAvailability(false);
    setPriceRange([0, 1000]);
  };

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const products = [
    {
      id: 1,
      name: "Smartphone",
      price: 499,
      image:
        "https://st5.depositphotos.com/7813332/73696/i/600/depositphotos_736962076-stock-photo-close-woman-hand-holding-mobile.jpg",
      title: "vivo T3x 5G (Celestial Green, 128 GB)  (4 GB RAM)",
      salePrice: "400",
    },
    {
      id: 2,
      name: "Laptop",
      price: 999,
      image:
        "https://st.depositphotos.com/1091429/2158/i/600/depositphotos_21587763-stock-photo-laptop-and-tablet-workplace-businessman.jpg",
      title: "Lenovo IdeaPad S14 15 (Intel Core i5-1135G7, 8GB RAM, 256GB SSD)",
      salePrice: "700",
    },
    {
      id: 3,
      name: "Headphones",
      price: 199,
      image:
        "https://st.depositphotos.com/1001686/3728/i/600/depositphotos_37285385-stock-photo-headphones-isolated-on-white-background.jpg",
      title: "Sony WH-1000XM3 Wireless Bluetooth Headphones (Black)",
      salePrice: "180",
    },
    {
      id: 4,
      name: "Smartwatch",
      price: 299,
      image:
        "https://st2.depositphotos.com/2019955/10432/i/600/depositphotos_104322932-stock-photo-man-with-smart-watch-and.jpg",
      title: "Apple Watch Series 6 (GPS, 44mm, Space Gray Aluminum Case)",
      salePrice: "250",
    },
    {
      id: 5,
      name: "Tablet",
      price: 399,
      image:
        "https://st5.depositphotos.com/62628780/75455/i/600/depositphotos_754559924-stock-photo-browsing-tablet-hands-person-office.jpg",
      title: "Samsung Galaxy Tab S6 (2020, 128GB, 10.5-inch, 6GB RAM)",
      salePrice: "350",
    },
    {
      id: 6,
      name: "Camera",
      price: 799,
      image:
        "https://st.depositphotos.com/2319941/2491/i/600/depositphotos_24917869-stock-photo-camera.jpg",
      title: "Sony PlayStation 5 (2020, 1TB, 1080p, 1TB HDD)",
      salePrice: "350",
    },
    {
      id: 7,
      name: "Speaker",
      price: 99,
      image:
        "https://st5.depositphotos.com/1439888/73563/i/600/depositphotos_735636324-stock-photo-pink-megaphone-rendering-isolated-white.jpg",
      title: "Bose SoundLink Wireless Bluetooth Speaker (Black)",
      salePrice: "80",
    },
    {
      id: 8,
      name: "Monitor",
      price: 299,
      image:
        "https://st4.depositphotos.com/13324256/25411/i/600/depositphotos_254116302-stock-photo-selective-focus-computer-blank-screen.jpg",
      title: "Acer Predator XC 15 (15.6-inch, 16GB RAM, 512GB SSD)",
      salePrice: "250",
    },
    {
      id: 9,
      name: "Keyboard",
      price: 49,
      image:
        "https://st.depositphotos.com/2075661/2293/i/600/depositphotos_22934440-stock-photo-illuminated-keyboard.jpg",
      title: "Logitech G930 Racing Mouse (Black)",
      salePrice: "35",
    },
    {
      id: 10,
      name: "Mouse",
      price: 29,
      image:
        "https://st4.depositphotos.com/11328482/20775/i/600/depositphotos_207757016-stock-photo-black-mouse-keyboard-isolated-dark.jpg",
      title: "Razer DeathAdder Elite (Black)",
      salePrice: "20",
    },
    // Additional 20 products
    {
      id: 11,
      name: "Smartphone",
      price: 599,
      image:
        "https://st5.depositphotos.com/7813332/73696/i/600/depositphotos_736962076-stock-photo-close-woman-hand-holding-mobile.jpg",
      title: "Samsung Galaxy S21 (128GB, 8GB RAM)",
      salePrice: "550",
    },
    {
      id: 12,
      name: "Laptop",
      price: 1299,
      image:
        "https://st.depositphotos.com/1091429/2158/i/600/depositphotos_21587763-stock-photo-laptop-and-tablet-workplace-businessman.jpg",
      title: "Apple MacBook Pro 13-inch (Intel Core i7, 16GB RAM, 512GB SSD)",
      salePrice: "1150",
    },
    {
      id: 13,
      name: "Headphones",
      price: 249,
      image:
        "https://st.depositphotos.com/1001686/3728/i/600/depositphotos_37285385-stock-photo-headphones-isolated-on-white-background.jpg",
      title: "Beats Studio 3 Wireless Noise Cancelling Over-Ear Headphones",
      salePrice: "199",
    },
    {
      id: 14,
      name: "Smartwatch",
      price: 499,
      image:
        "https://st2.depositphotos.com/2019955/10432/i/600/depositphotos_104322932-stock-photo-man-with-smart-watch-and.jpg",
      title: "Samsung Galaxy Watch 4 (Bluetooth, 44mm, Black)",
      salePrice: "420",
    },
    {
      id: 15,
      name: "Tablet",
      price: 699,
      image:
        "https://st5.depositphotos.com/62628780/75455/i/600/depositphotos_754559924-stock-photo-browsing-tablet-hands-person-office.jpg",
      title: "Apple iPad Pro (2020, 256GB, 12.9-inch)",
      salePrice: "630",
    },
    {
      id: 16,
      name: "Camera",
      price: 1200,
      image:
        "https://st.depositphotos.com/2319941/2491/i/600/depositphotos_24917869-stock-photo-camera.jpg",
      title: "Canon EOS 5D Mark IV DSLR Camera",
      salePrice: "950",
    },
    {
      id: 17,
      name: "Speaker",
      price: 149,
      image:
        "https://st5.depositphotos.com/1439888/73563/i/600/depositphotos_735636324-stock-photo-pink-megaphone-rendering-isolated-white.jpg",
      title: "JBL Charge 4 Wireless Bluetooth Speaker",
      salePrice: "130",
    },
    {
      id: 18,
      name: "Monitor",
      price: 399,
      image:
        "https://st4.depositphotos.com/13324256/25411/i/600/depositphotos_254116302-stock-photo-selective-focus-computer-blank-screen.jpg",
      title: "Dell UltraSharp U2719D 27-inch Monitor",
      salePrice: "350",
    },
    {
      id: 19,
      name: "Keyboard",
      price: 79,
      image:
        "https://st.depositphotos.com/2075661/2293/i/600/depositphotos_22934440-stock-photo-illuminated-keyboard.jpg",
      title: "Razer BlackWidow V3 Mechanical Keyboard",
      salePrice: "69",
    },
    {
      id: 20,
      name: "Mouse",
      price: 59,
      image:
        "https://st4.depositphotos.com/11328482/20775/i/600/depositphotos_207757016-stock-photo-black-mouse-keyboard-isolated-dark.jpg",
      title: "Logitech MX Master 3 Wireless Mouse",
      salePrice: "50",
    },
  ];

  const filteredProducts = products.filter((product) => {
    return (
      (selectedCategory ? product.category === selectedCategory : true) &&
      (selectedBrand.length ? selectedBrand.includes(product.brand) : true) &&
      (selectedDiscount ? product.price <= parseInt(selectedDiscount) : true) &&
      (selectedOffer ? product.name.includes(selectedOffer) : true) &&
      product.price >= priceRange[0] &&
      product.price <= priceRange[1] &&
      (availability ? product.inStock : true)
    );
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsSidebarVisible1(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full max-w-[90%] lg:max-w-[88%] mx-auto hidden sm:block">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          className="w-full"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                loading="lazy"
                src={image}
                alt={`Promotion ${index + 1}`}
                className="w-full h-auto sm:h-[250px] md:h-[350px] lg:h-[400px] object-cover rounded-lg"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="mx-[5%] md:hidden z-50 mt-[3%] bg-gray-200 flex flex-row justify-between px-2 items-center rounded">
        <button
          className="px-4 py-2  flex flex-row gap-1"
          onClick={() => {
            setIsSidebarVisible(!isSidebarVisible);
            setIsSidebarVisible1(false);
          }}
        >
          <MdFilterList size={24} className="text-gray-700" />
          <div className="text-gray-700 font-bold">Filter</div>
        </button>
        <div className="relative inline-block text-left ">
          <button
            className="px-4 py-2 m-2 flex flex-row bg-white rounded-2xl border border-gray-300 shadow-sm"
            onClick={() => setIsSidebarVisible1(!isSidebarVisible1)}
          >
            <div className="text-gray-700 font-bold truncate">
              {selectedOption}
            </div>
            <MdArrowDropDown className="text-gray-500 ml-2" size={24} />
          </button>

          {isSidebarVisible1 && (
            <div className="z-10 absolute mt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-60">
              {options.map((option, index) => (
                <div
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 text-black hover:bg-gray-100 cursor-pointer"
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center mb-[3%]">
        <aside
          id="filter-sidebar"
          // className={`w-3/5 md:w-full lg:w-full bg-white p-6 shadow-lg transition-all duration-300 sm:mt-8 mt-0 ${
          //   isSidebarVisible
          //     ? "fixed top-0 left-0 z-40 h-full overflow-y-auto"
          //     : "hidden md:block"
          // } md:sticky md:top-0 md:h-screen md:overflow-y-auto md:max-h-screen`}
          className={`w-3/5 md:w-full lg:w-full bg-white p-6 shadow-lg transition-all duration-300 mt-0 ${isSidebarVisible
            ? "fixed top-0 left-0 z-40 h-full overflow-y-auto"
            : "hidden md:block"
            } md:sticky md:top-0 md:h-screen md:overflow-y-auto md:max-h-screen`}
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          <button
            className="absolute top-2 right-2 text-white bg-red-600 rounded-full px-3 py-1"
            onClick={() => setIsSidebarVisible(false)}
          >
            X
          </button>
          <h3 className="text-black font-bold text-xl sm:text-1xl md:text-4xl lg:text-1xl">
            Filters
          </h3>

          <button
            className="text-blue-600 mb-6 hover:text-blue-800 mt-3"
            onClick={handleClearAll}
          >
            Clear All
          </button>

          {/* Category Filter */}
          <div>
            <h4 className="text-2xl font-semibold text-black">CATEGORIES</h4>
            <ul className="list-none mt-4">
              {categories.map((category, index) => (
                <li
                  key={index}
                  className={`cursor-pointer text-black mb-3 text-1xl hover:text-blue-600 ${selectedCategory === category
                    ? "font-bold text-blue-600"
                    : ""
                    }`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6">
            <h4 className="text-2xl font-semibold text-black">DISCOUNT</h4>
            <ul className="list-none mt-4">
              {discounts.map((discount, index) => (
                <li
                  key={index}
                  className={`cursor-pointer text-black mb-3 text-sm hover:text-blue-600 ${selectedDiscount === discount
                    ? "font-bold text-blue-600"
                    : ""
                    }`}
                  onClick={() => setSelectedDiscount(discount)}
                >
                  {discount}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6">
            <h4 className="text-2xl font-semibold text-black">BRAND</h4>
            <ul className="list-none mt-4">
              {brands.map((brand, index) => (
                <li key={index} className="flex items-center mb-3 text-1xl">
                  <input
                    type="checkbox"
                    checked={selectedBrand.includes(brand)}
                    onChange={() => {
                      if (selectedBrand.includes(brand)) {
                        setSelectedBrand(
                          selectedBrand.filter((b) => b !== brand)
                        );
                      } else {
                        setSelectedBrand([...selectedBrand, brand]);
                      }
                    }}
                    className="mr-2"
                  />
                  <label className="cursor-pointer text-black-600 hover:text-blue-600">
                    {brand}
                  </label>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6">
            <h4 className="text-2xl font-semibold text-black">OFFERS</h4>
            <ul className="list-none mt-4">
              {offers.map((offer, index) => (
                <li
                  key={index}
                  className={`cursor-pointer text-black mb-3 text-sm hover:text-blue-600 ${selectedOffer === offer ? "font-bold text-blue-600" : ""
                    }`}
                  onClick={() => setSelectedOffer(offer)}
                >
                  {offer}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6">
            <h4 className="text-2xl font-semibold text-black">AVAILABILITY</h4>
            <div className="flex items-center mt-2">
              <input
                type="checkbox"
                checked={availability}
                onChange={() => setAvailability(!availability)}
                className="mr-2"
              />
              <label className="text-sm text-black">Include Out of Stock</label>
            </div>
          </div>

          <div className="mt-6">
            <h4 className="text-lg font-semibold text-black">PRICE RANGE</h4>
            <input
              type="range"
              className="w-full mt-2"
              min="0"
              max="1000"
              value={priceRange[1]}
              onChange={(e) => setPriceRange([0, Number(e.target.value)])}
            />
            <div className="flex justify-between mt-2 text-sm">
              <span>₹{priceRange[0]}</span>
              <span>₹{priceRange[1]}</span>
            </div>
          </div>
        </aside>

        <div className="w-full sm:w-[95%] md:w-[100%] mt-5">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2  sm:gap-1 lg:gap-3 sm:mt-3 mt-0">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className="bg-white shadow rounded-md overflow-hidden relative  border border-gray-200 sm:px-8 sm:py-3 px-3 py-2"
                >
                  <img
                    loading="lazy"
                    src={product.image}
                    alt={product.name}
                    className="w-full h-20 sm:h-40 object-contain bg-light  rounded-xl "
                  />
                  <button
                    className="like-btn absolute top-2 left-2"
                    onClick={() => toggleLike(product.id)}
                  >
                    {likedProducts.has(product.id) ? (
                      <FaHeart
                        size="24px"
                        className="text-red-500 sm:text-lg text-xs"
                      />
                    ) : (
                      <FaRegHeart
                        size="24px"
                        className="text-gray-400 sm:text-lg md:text-xs"
                      />
                    )}
                  </button>
                  {product?.outOfStock ? <span className=" absolute bg-gray-200 top-2 right-2  p-1  text-red-500 text-bold text-gray-400 sm:ml-20 ml-0">
                    Out of stock
                  </span> :
                    <button className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50">
                      <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                    </button>
                  }
                  <Link
                    to={`/shop/${product?.category ? generateSlug(product?.category) : "-"
                      }/${product?.subcategory
                        ? generateSlug(product?.subcategory)
                        : "-"
                      }/${product?.title ? generateSlug(product?.title) : "-"}`}
                    state={{ product }}

                    className="block "
                  >
                    <div className=" mb-1 end-2 lg:mt-3">
                      <h2 className="sm:text-xl text-xs text-black  from-neutral-600 sm:mt-0 mt-3">
                        {product.name}
                      </h2>
                      <h2
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        className="text-sm"
                      >
                        {product.title}
                      </h2>
                      <div className="mt-2 flex justify-between items-center me-2">
                        <div className={`${CustomeStyle.row} space-x-1`}>
                          <span className={CustomeStyle.text}>
                            ₹{product.salePrice}
                          </span>
                          <span
                            className={CustomeStyle.text}
                            style={{ textDecoration: "line-through" }}
                          >
                            ₹{product.price}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-row text-xs sm:text-1xl ">
                        ⭐⭐⭐⭐
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="text-center text-lg font-semibold">
                No Data Found
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SubCategoryData;
